import { DirectionalHint } from "@fluentui/react";
import React, { FunctionComponent } from "react";
import { CoachmarkInfo } from "../CoachmarkInfo";
import { PFCoachmark } from "../PFCoachmark";
import { useTranslation } from "../../Locales/i18n/localizationService";
import { CoachmarkLocaleItem } from "../../Locales/Coachmarks/Locale_CoachmarkItem";

export const TimelineCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const timelineResolutionText = new CoachmarkLocaleItem(t("Coachmarks.Generic.TimelineResolution.Headline"), t("Coachmarks.Generic.TimelineResolution.Text"));
	const timelineTableText = new CoachmarkLocaleItem(t("Coachmarks.Generic.TimelinePeriod.Headline"), t("Coachmarks.Generic.TimelinePeriod.Text"));
	const _timelineResolution = new CoachmarkInfo("timeline-resolution", "#timelinemenubutton", timelineResolutionText, DirectionalHint.rightTopEdge);
	const _timelineTable = new CoachmarkInfo("timeline-table", "#tp-timeline-modern-table", timelineTableText, DirectionalHint.bottomCenter);

	return	<>
				<PFCoachmark CoachmarkInfo={_timelineResolution} />
				<PFCoachmark CoachmarkInfo={_timelineTable} />
			</>
})